import { Component } from '@angular/core';
import { Router, UrlSerializer, ActivatedRoute } from '@angular/router';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { TableMode } from 'src/app/components/grid/grid.component';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IColumn } from 'src/app/components/grid/IColumn';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IExam, UserModel } from 'src/app/interface/dto';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent {
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Username',
      fieldName: 'username',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Name',
      fieldName: 'name',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Email Address',
      fieldName: 'emailAddress',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Default Company',
      fieldName: 'defaultCompany',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Force Change Password',
      fieldName: 'forceChangePassword',
      fieldDataType: FieldDataType.boolean,
      searchable: false,
      orderable: true,

    }
  ];
  gridName = 'usersGrid';
  selectedUsers: UserModel[] = [];
  constructor(private userService: UserService, private router: Router,
    private serializer: UrlSerializer, private snackBar: SnackbarService, private eventService: EventService) {
  }

  async ngOnInit() {
    this.setUsers([]);
    this.userService.reloadGrid.subscribe((value) => {
      this.refreshData(this.data.tableParams);
    });
    await this.refreshData(this.data.tableParams);
  }

  setUsers(users: UserModel[]) {
    this.selectedUsers = users;
    this.userService.setSelectedUser([...this.selectedUsers]);
  }

  setUserData(rowIds: any[]) {
    if (!this.data?.tableRows?.length) { //Just in case tableRows might still not be ready
      setTimeout(() => this.setUserData(rowIds), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedExams: UserModel[] = rowIds.map(x => this.data.tableRows[x] as UserModel).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedExams.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, rowIds, selectedDataRowsId);
    this.setUsers(selectedExams);
  }
  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  async refreshData(tableParams) {
    const res = await this.userService.getUsers(tableParams) as any[];
    this.updateGridParams(res);
  }

  copyUserClicked(event: any) {
    this.router.navigate([`create_user/${this.userService.selectedUserIds[0]}`], {
      queryParams: { mode: 'copy' }
    });
  }
  veiwAllUserData(examIds: any[]) {
    const selectedUsers: any[] = [];
    examIds.forEach(x => selectedUsers.push(this.data.tableRows[x]));
    this.setUsers(selectedUsers);
    this.router.navigate([`create_user/${this.userService.selectedUserIds[0]}`], {
      queryParams: { mode: 'view-all' }
    });
  }
  addUserClicked() {
    this.router.navigate(['create_user/0']);
  }

  editUserClicked(event: any) {
    this.router.navigate([`create_user/${this.userService.selectedUserIds[0]}`], {
      queryParams: { mode: 'edit' }
    });
  }

  async deleteUserClicked() {
    let data = { examIds: this.userService.selectedUserIds };
    const reportTree = this.router.createUrlTree([], { queryParams: data });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];

    await this.userService.deleteUser(params).then(async () => {
      await this.refreshData(this.data.tableParams);
      this.snackBar.success("User deleted successfully");
    });
  }
}
